import { Box, Grid, styled, Typography } from '@mui/material';
import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import useLocales from '../../hooks/useLocales';
import Image from '../../components/Image';
import { calculateFontSize } from '../../utils/formatString';

const NavButtonWrapper = styled(Box)(({ theme, isActive }) => ({
  background: 'linear-gradient(273.4deg, rgba(255, 255, 255, 0) 12.81%, rgba(255, 255, 255, 0.78) 96.52%)',
  height: '100%',
  minHeight: '36px',
  //   minWidth: '92px',
  borderRadius: '5px',
  display: 'flex',
  alignItems: 'center',
  gap: '2px',
  cursor: 'pointer',
  ...(isActive && {
    background: 'linear-gradient(273.4deg, rgba(58, 0, 152, 0) 12.81%, #0028C9 96.52%)',
    boxShadow: '0px 0px 8.9px 1px #00A3FF',
  }),
}));

const NavButtonIconWrapper = styled(Box)(({ theme }) => ({
  width: '30%',
}));

const NavButtonTitle = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 600,
  textShadow: '0px 1px 2px 0px #000000BF',
}));

const NavButtons = [
  {
    title: 'highlights',
    icon: require('../../assets/home/nav-spotlight.webp'),
    href: '/home',
  },
  {
    title: 'promotions',
    icon: require('../../assets/home/nav-promo.webp'),
    href: '/promotion',
  },
  //   {
  //     title: 'event',
  //     icon: require('../../assets/home/nav-events.png'),
  //     href: '/',
  //   },
  //   {
  //     title: 'information',
  //     icon: require('../../assets/home/nav-info.png'),
  //     href: '/',
  //   },
];

const HomeNavRow = () => {
  const { translate } = useLocales();

  const navigate = useNavigate();

  const location = useLocation();

  return (
    <Grid container spacing={1}>
      {NavButtons.map((x, idx) => (
        <Grid item xs={3} key={idx}>
          <NavButtonWrapper isActive={location.pathname === x.href} onClick={() => navigate(x.href)}>
            <NavButtonIconWrapper>
              <Image src={x.icon} sx={{ width: '100%' }} />
            </NavButtonIconWrapper>

            <NavButtonTitle
              sx={{
                fontSize: {
                  xs: calculateFontSize(x.title, 11, 8),
                  sm: calculateFontSize(x.title, 14, 9),
                  md: calculateFontSize(x.title, 16, 10),
                  lg: calculateFontSize(x.title, 17, 10),
                },
              }}
            >
              {translate(x.title)}
            </NavButtonTitle>
          </NavButtonWrapper>
        </Grid>
      ))}
    </Grid>
  );
};

export default HomeNavRow;
